// === Helper de formato VE (1.000,00) ===
const _veFormatter =
  typeof Intl !== "undefined" && Intl.NumberFormat
    ? new Intl.NumberFormat("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : null;

function formatVE(n) {
  const num = Number(n) || 0;
  if (_veFormatter) return _veFormatter.format(num);
  // Fallback manual: 1234567.89 -> 1.234.567,89
  const parts = num.toFixed(2).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return parts.join(",");
}

// === TASA BCV desde dolarapi.com ===
async function getBCVRate() {
  try {
    const res = await fetch("https://ve.dolarapi.com/v1/dolares/oficial");
    const data = await res.json();
    // Guardamos como número; se formatea solo al pintar
    return Number(data.promedio);
  } catch (error) {
    console.error("Error obteniendo tasa BCV:", error);
    return null;
  }
}

// === Cálculo de total en Bs y almacenamiento en window.cart
async function calcularBCVConversion() {
  const rate = await getBCVRate();
  if (!rate) return;

  // Pedir el JSON actualizado del carrito desde Shopify
  let cart;
  try {
    const res = await fetch("/cart.js");
    cart = await res.json();
  } catch (e) {
    console.error("Error leyendo /cart.js:", e);
    return;
  }

  const usd = (cart.total_price || 0) / 100;
  const bs = usd * rate;

  // Guardar variables globales (numéricas)
  window.cart = window.cart || {};
  window.cart.total_price_usd = usd;
  window.cart.total_price_bs = bs;
  window.cart.bcv_rate = rate;

  // Disparar evento personalizado
  const event = new CustomEvent("bcv:ready", {
    detail: { usd, bs, rate },
  });
  document.dispatchEvent(event);
}

// === Pintar los valores donde corresponda (con formato VE)
function updateBsCartValues() {
  if (!window.cart) return;

  const elBs = document.getElementById("cart-total-bs");
  const elRate = document.getElementById("cart-rate-bs");

  if (elBs && typeof window.cart.total_price_bs === "number") {
    elBs.innerText = `Bs ${formatVE(window.cart.total_price_bs)}`;
  }

  if (elRate && typeof window.cart.bcv_rate === "number") {
    elRate.innerText = `Bs ${formatVE(window.cart.bcv_rate)}`;
  }
}

// === Mostrar conversión en la página de producto (con formato VE) ===
function updateProductPriceBs() {
  const productPriceEl = document.querySelector("[data-product-price]");
  const productPriceBsEl = document.getElementById("product-price-bs");

  if (!productPriceEl || !productPriceBsEl || !window.cart?.bcv_rate) return;

  const priceCents = parseFloat(productPriceEl.getAttribute("data-product-price"));
  if (!priceCents && priceCents !== 0) return;

  const priceUsd = priceCents / 100;
  const priceBs = priceUsd * window.cart.bcv_rate;

  productPriceBsEl.innerText = `Bs ${formatVE(priceBs)}`;
}

// === Inicialización y escucha de cambios ===
document.addEventListener("DOMContentLoaded", () => {
  calcularBCVConversion().then(() => {
    updateBsCartValues();
    updateProductPriceBs();
  });
});
document.addEventListener("bcv:ready", () => {
  updateBsCartValues();
  updateProductPriceBs();
});

// Shopify AJAX cart / temas que actualizan dinámicamente
[
  "contentUpdated",
  "ajax:cart:updated",
  "ajax:addToCart",
  "ajax:updateCart",
].forEach((evt) => {
  document.body.addEventListener(evt, () => {
    calcularBCVConversion().then(() => {
      updateBsCartValues();
      updateProductPriceBs();
    });
  });
});

// Variantes dinámicas en producto (si el tema dispara este evento)
document.addEventListener("variant:changed", (e) => {
  if (e.detail?.variant?.price != null) {
    const productPriceEl = document.querySelector("[data-product-price]");
    if (productPriceEl) {
      productPriceEl.setAttribute("data-product-price", e.detail.variant.price);
      updateProductPriceBs();
    }
  }
});
